import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useGetBundleDataQuery } from 'features/pricing/pricingSlice';
import { initializeBundleForEdit } from '../bundleStateSlice';
import { mapServerPricingToStepFormat, mapServerRulesToStepFormat } from '../../CreateActivityAndPricing/utils/editMappingUtils';

const useGetBundleData = ({ bundleId, open, enabled, prefill }) => {
    const dispatch = useDispatch();
    const [initializedBundleId, setInitializedBundleId] = useState(null);

    const { data: bundleData, isLoading, isFetching } = useGetBundleDataQuery(
        bundleId,
        {
            skip: !bundleId || !open || !enabled,
            refetchOnMountOrArgChange: true
        }
    );

    const serverPricing = bundleData?.pricing || [];
    const serverRules = bundleData?.rules || [];
    const ruleParamTypes = bundleData?.ruleParamTypes || [];
    const bundle = bundleData?.bundle;
    const activityItemIds = bundleData?.activityItemIds || [];

    const isDataLoaded = !enabled || (!isLoading && !isFetching);

    useEffect(() => {
        if (!enabled || !open || !bundleId || !isDataLoaded || !bundleData || !bundle) {
            return;
        }

        if (initializedBundleId === bundle.id) {
            return;
        }

        const bundleDetails = {
            name: bundle.name,
            description: bundle.description || '',
            activityItemIds: activityItemIds,
            paramTypes: ruleParamTypes.map(rp => ({
                id: rp.id,
                paramType: rp.paramType,
                paramSubType: rp.paramSubType,
                activityId: rp.activityId,
                bundleId: rp.bundleId
            }))
        };

        const pricingItems = mapServerPricingToStepFormat(serverPricing, [], []).map(item => ({
            ...item,
            price: item.priceConfig?.charge ?? item.priceConfig?.price ?? null
        }));
        const rulesList = mapServerRulesToStepFormat(serverRules);

        dispatch(
            initializeBundleForEdit({
                editBundleId: bundle.id,
                bundleDetails,
                pricingItems,
                rulesList,
                prefill,
            })
        );
        setInitializedBundleId(bundle.id);
    }, [bundleData, enabled, open, bundleId, isDataLoaded, initializedBundleId]);

    useEffect(() => {
        if (!open) {
            setInitializedBundleId(null);
        }
    }, [open]);

    return {
        isDataLoaded,
        serverPricing,
        serverRules,
    };
};

export default useGetBundleData;
